import styled from 'styled-components'
import { transparentize } from "polished";

export const CheckboxContainer = styled.div`
  display: inline-flex;
  align-self: flex-start;
  padding: 15px 0 5px 0;
  cursor: pointer;
`

export const Icon = styled.svg`
  fill: none;
  stroke: ${props => props.theme.colors.primary};
  stroke-width: 4px;
`;

export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

export const StyledCheckbox = styled.div`
  display: flex;
  width: 20px;
  height: 20px;
  border-radius: 3px;
  transition: all 150ms;
  border: 1px solid ${props => props.theme.colors.primary};
  cursor: pointer;

  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 3px ${props => transparentize(0.9, props.theme.colors.primary)};
  }

  ${Icon} {
    visibility: ${props => (props.checked ? 'visible' : 'hidden')};
  }
`;

export const Label = styled.label`
  margin: 0;
  padding-left: 10px;
  transition: all 0.3s ease;
  font-family: 'DM Sans', system-ui, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  cursor: pointer;
  user-select: none;
`;
